import React from 'react';
import styles from './SearchBarFilterSelection.module.scss';
import Tag from './Tag';
import Icon from '../icons/Icon';

function SearchBarFilterSelection(props) {
    const { tags, selectedTags, onRemoveTag, onClearFilter } = props;

    const currentSelectionTags = _(selectedTags)
        .map((options, tag) => {
            return _(options || [])
                .map((name) => _(tags).chain().find({ name: tag }).get('options').find({ name }).value())
                .compact()
                .map((option) => (
                    <Tag key={tag + '-' + option.name} tag={tag} option={option} color={option.color} onRemove={onRemoveTag}>
                        {option.name}
                    </Tag>
                ))
                .value();
        })
        .flatten()
        .map((tag) => [tag, ' '])
        .flatten()
        .value();

    return (
        <div className={styles.FilterSelection} style={{ display: currentSelectionTags.length ? '' : 'none' }}>
            {currentSelectionTags}
            <button type="button" className={styles.clearAll} onClick={onClearFilter}>
                <Icon color="white" src="/img/reject_icon.png" />
            </button>
        </div>
    );
}

export default SearchBarFilterSelection;
